import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createSlots as _createSlots, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content" }

import {ref, inject, onMounted} from 'vue';
	import {useRouter} from 'vue-router';
	import NavBar from './components/NavBar.vue';
	import ModalWindow from './components/ModalWindow.vue';
	import LoginPage from './pages/LoginPage.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	const emitter = inject('emitter');
	emitter.on('showMessage', (value: {message: '', header: ''} | string) => onShowMessage(value));
	emitter.on('unauthorized', () => onUnauthorized());
	emitter.on('authorized', () => onAuthorized());
	emitter.on('forbidden', () => onForbidden());

	const router = useRouter();
	const modalVisible = ref(false);
	const modalMessage = ref('');
	const modalHeader = ref('');
	const authorized = ref(false);
	const authorizationNotRequired = ref(true);

	const allowedRoutes = [
		'login',
		'register',
		'forgot',
		'reset'
	];

	onMounted(() => {
		if(localStorage.token != undefined) {
			authorized.value = true;
			emitter.emit('authorized');
		}
	});

	router.beforeEach(async (to) => {
		if(authorized.value == false) {
			if(allowedRoutes.filter(x => x == to.name).length == 0)
				return {name: 'login'};

			return true;
		}
		else {
			if(to.name == 'login')
				return {name: 'root'};
		}

		if(!to.path.startsWith('/admin'))
			return true;

		const player = JSON.parse(localStorage.player);
		if(!player.isAdmin)
			return false;

		return true;
	});

	router.beforeResolve(async (to) => {
		if(allowedRoutes.filter(x => x == to.name).length > 0)
			authorizationNotRequired.value = true;
		else
			authorizationNotRequired.value = false;
	})

	function modalClose() {
		modalVisible.value = false;
	}

	function onShowMessage(value: {message: '', header: ''} | string) {
		modalVisible.value = true;
		if(typeof(value) === 'string') {
			modalMessage.value = value;
			modalHeader.value = '';
			return;
		}		

		modalMessage.value = value.message;
		modalHeader.value = value.header;
	}

	function onUnauthorized() {
		authorized.value = false;
		localStorage.removeItem('token');
		localStorage.removeItem('player');
	}

	function onAuthorized() {
		authorized.value = true;
	}

	function onForbidden() {
		router.push('/');
	}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar, { title: "Formule 1 App" }),
    _createElementVNode("div", _hoisted_1, [
      (authorized.value || authorizationNotRequired.value)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : (_openBlock(), _createBlock(LoginPage, {
            key: 1,
            unauthorized: true
          })),
      _withDirectives(_createVNode(ModalWindow, { onClose: modalClose }, _createSlots({ _: 2 }, [
        (modalMessage.value.length > 0)
          ? {
              name: "content",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(modalMessage.value), 1)
              ]),
              key: "0"
            }
          : undefined,
        (modalHeader.value.length > 0)
          ? {
              name: "header",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(modalHeader.value), 1)
              ]),
              key: "1"
            }
          : undefined
      ]), 1536), [
        [_vShow, modalVisible.value]
      ])
    ])
  ], 64))
}
}

})